import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";

import { Header, Results, AddRole } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const MasterRoutes = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [isadd, setIsadd] = useState(false);
  const [roleobj, setRoleobj] = useState({});
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const snackbarCtx = React.useContext(SnackBarContext);
  async function fetchmodules()
{
   // let masterroles_arr = await sendNetworkRequest('/getmodules', {}, {},false)
  //  setOrders(masterroles_arr.module)
  setOrders([
    {
      "id":1,
      "name":"Employee Management",
      "createdAt":"17 Nov 2022 10:20 AM",
      "status":false
    },
    {
      "id":1,
      "name":"Role Management",
      "createdAt":"17 Nov 2022 10:20 AM",
      "status":true
    },
    {
      "id":1,
      "name":"Role Access Management",
      "createdAt":"17 Nov 2022 10:20 AM",
      "status":true
    },
    {
      "id":1,
      "name":"Language Management",
      "createdAt":"17 Nov 2022 10:20 AM",
      "status":true
    },
  ])
}
 
  function dismiss()
  {
    setIsadd(false)
  }
  function addrole()
  {
    setIsadd(true)
  }
  function editrole(roleobj)
  {
    setRoleobj(roleobj)
    setIsadd(true)
  }
  async function updaterolestatus(roleobj, status)
  {
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: "success",
      msg: "Status Change Successfully" ,
      vertical: "top",
    });
    // let bodycontent = {}
    // bodycontent['isactive'] = status;

    // if(roleobj)
    // {
    //   bodycontent['role_id'] = roleobj.id;
    //   bodycontent['name'] = roleobj.name;

     
    // }
    // let masterroles_arr = await sendNetworkRequest('/updaterole', {}, bodycontent,false)
    // snackbarCtx.setSnack({
    //   ...snackbarCtx,
    //   open: true,
    //   type: masterroles_arr.status,
    //   msg: masterroles_arr.message,
    //   vertical: "top",
    // });
    fetchmodules()
  }
  async function updaterole(rolename,roleobj)
  {
    let bodycontent = {}
    bodycontent['name'] = rolename;
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: "success",
      msg: roleobj && roleobj.id ? "Edited Successfully" : "Added Successfully" ,
      vertical: "top",
    });
    // if(roleobj && roleobj.id)
    // {
    
    //   bodycontent['role_id'] = roleobj.id;
    // bodycontent['isactive']  = roleobj.isactive 
    // let masterroles_arr = await sendNetworkRequest('/updaterole', {}, bodycontent,false)
    // snackbarCtx.setSnack({
    //   ...snackbarCtx,
    //   open: true,
    //   type: masterroles_arr.status,
    //   msg: masterroles_arr.message,
    //   vertical: "top",
    // });
    // }else{
    
    //   let masterroles_arr = await sendNetworkRequest('/addrole', {}, bodycontent,false)
    //   snackbarCtx.setSnack({
    //     ...snackbarCtx,
    //     open: true,
    //     type: masterroles_arr.status,
    //     msg: masterroles_arr.message,
    //     vertical: "top",
    //   });
    // }
    

    setIsadd(false)
    setRoleobj({})

    fetchmodules()
  }
  useEffect(() => {
   fetchmodules()
  }, []);

  return (
    <Page
      className={classes.root}
      title="Routes Management"
    >
      <Header onAdd={addrole}/>
      {isadd ? <AddRole onUpdate={updaterole} onDismiss={dismiss} roleObj={roleobj}/> : null }
      <Results
        onEdit={editrole}
        onUpdatestattus={updaterolestatus}
        onupdatestatus={editrole}
        className={classes.results}
        orders={orders} //
      />
    </Page>
  );
});

export default MasterRoutes;
